import { useLocation } from 'react-router-dom';

export const useParamQuery = () => {
  return new URLSearchParams(useLocation().search);
};
